import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Instalar como app: el navegador avisa una sola vez, muy temprano, que se
// puede instalar. Lo guardamos para el botón "Instalar Kontrol" (InstalarApp).
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__instalarKontrol = e;
  window.dispatchEvent(new Event('kontrol-instalable'));
});
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
